import Chip from '@components/Chip';
import styled from '@emotion/styled';
import { pressActionEffect } from '@styles/mixin';

interface Props {
    categories: string[];
    selected: string;
    onSelect: (categoryName: string) => void;
}

function CategoryTabs({ categories, selected, onSelect }: Props) {
    return (
        <Scroll>
            <List>
                {categories.map((name) => (
                    <Chip key={name}
                        isSelected={name === selected}
                        aria-label={name}
                        onClick={() => onSelect(name)}
                        css={pressActionEffect}>
                        {name}
                    </Chip>
                ))}
            </List>
        </Scroll>
    );
}

const Scroll = styled.div`
    overflow-x: auto;
    width: 100%;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const List = styled(Chip.Container)`
    padding: var(--spacing-6) var(--spacing-4);
    width: max-content;
`;

export default CategoryTabs;
